module.exports = __webpack_public_path__ + "static/assets/e917dd7fe3601152bcd05c37d644a3f0.gif";